const GEMINI_API_KEY = 'gemini_api_key';

/**
 * Save Gemini API token to localStorage
 */
export const saveApiToken = (token: string): void => {
  try {
    localStorage.setItem(GEMINI_API_KEY, token.trim());
  } catch (error) {
    console.error('Failed to save API token:', error);
    throw new Error('Failed to save API token to localStorage');
  }
};

/**
 * Retrieve Gemini API token from localStorage
 */
export const getApiToken = (): string | null => {
  try {
    return localStorage.getItem(GEMINI_API_KEY);
  } catch (error) {
    console.error('Failed to retrieve API token:', error);
    return null;
  }
};

/**
 * Clear/remove Gemini API token from localStorage
 */
export const clearApiToken = (): void => {
  try {
    localStorage.removeItem(GEMINI_API_KEY);
  } catch (error) {
    console.error('Failed to clear API token:', error);
    throw new Error('Failed to clear API token from localStorage');
  }
};

/**
 * Validate token format (basic check)
 * Google API keys typically start with "AIza" and are 39 characters long
 */
export const validateApiToken = (token: string): { valid: boolean; message?: string } => {
  const trimmedToken = token.trim();
  
  if (!trimmedToken) {
    return { valid: false, message: 'API token cannot be empty' };
  }
  
  if (trimmedToken.length < 20) {
    return { valid: false, message: 'API token appears to be too short' };
  }
  
  // Google API keys typically start with "AIza"
  if (!trimmedToken.startsWith('AIza')) {
    return { 
      valid: true, // Still allow it, but warn
      message: 'Warning: Google API keys typically start with "AIza". Please verify your key.'
    };
  }
  
  return { valid: true };
};

/**
 * Check if API token is configured
 */
export const hasApiToken = (): boolean => {
  const token = getApiToken();
  return !!token && token.trim().length > 0;
};
